const DEVICE_ID_KEY = 'device_id'

export function deviceId(key = DEVICE_ID_KEY) {
  let id: string | null = null
  let generated = false
  if (typeof window !== 'undefined') {
    id = window.localStorage.getItem(key)
  } else {
    console.warn(
      'Device Id will always be generated when there is no localStorage'
    )
  }
  if (!id) {
    id = crypto.randomUUID()
    generated = true
  }
  if (typeof window !== 'undefined' && generated) {
    window.localStorage.setItem(key, id)
  }
  return { id: id!, generated }
}
